export default {
  text: [
    'Contains measures of macroeconomic risks to the financial system such as inflation, excessive government borrowing, and excessive reliance on cross-border financing.',
    'Contains measures of market risk such as excessive valuations, low risk premiums, and excesses in financial risk appetite and risk-taking. ',
    'Contains measures of credit risk in the real economy &mdash; the risk of widespread credit defaults or delinquencies by households and nonfinancial businesses.',
    'Contains measures of excessive leverage at financial institutions or other risks to their solvency.',
    'Contains measures of risks in short-term funding arrangements and liquidity for financial markets and financial institutions.',
    'Contains measures of potential vulnerabilities from stress transmission across financial institutions and markets, within concentrated financial sectors, and from other countries to the U.S. financial system.',
  ],
};



// WEBPACK FOOTER //
// ./src/toolTipsText.js